<script setup lang="ts">
import sasVerticalLogo from '@/images/logos/sas-vertical.png';
</script>

<template>
  <footer class="flex flex-col shadow-[0_-1px_3px_rgba(0,0,0,0.1)]">
    <div class="container flex bg-white py-60 max-xl:flex-col xl:gap-50">
      <div class="border-green flex flex-col items-center gap-30 max-xl:border-b max-xl:pb-20">
        <img class="w-90" :src="sasVerticalLogo" alt="Student Assurance Services" />
        <RouterLink to="/contactus" class="btn-outline-green">Contact Us</RouterLink>
      </div>
      <div class="grid flex-auto grid-cols-10 gap-y-20">
        <div class="footer-menu col-span-5 lg:col-span-2">
          <RouterLink to="/k12">K 12</RouterLink>
          <RouterLink to="/k12">K12 Students</RouterLink>
          <RouterLink to="/k12/admin/login">K12 Administrators</RouterLink>
        </div>
        <div class="footer-menu col-span-5 lg:col-span-2">
          <RouterLink to="/college">College</RouterLink>
          <RouterLink to="/college">College Students</RouterLink>
          <RouterLink to="/college/admin/login">College Administrators</RouterLink>
        </div>
        <div class="footer-menu col-span-5 lg:col-span-2">
          <RouterLink to="/specialrisk">Special Risk</RouterLink>
        </div>
        <div class="footer-menu col-span-5 lg:col-span-2">
          <RouterLink to="/aboutus">About Us</RouterLink>
          <RouterLink to="/aboutus/allproducts">Product &amp; Services</RouterLink>
          <RouterLink to="/aboutus/requestinfo">Request Information</RouterLink>
          <RouterLink to="/aboutus/faq">FAQs</RouterLink>
        </div>
        <div class="footer-menu col-span-full lg:col-span-2">
          <RouterLink to="/providers">Providers</RouterLink>
        </div>
      </div>
    </div>
    <div class="bg-green font-poppins py-15 text-center text-white">
      <span>&copy;2020-2026 Student Assurance Services, Inc. All rights reserved.</span>
      <RouterLink class="link-arrow ml-8" to="/privacy">Privacy Notices</RouterLink>
    </div>
  </footer>
</template>
